import React from "react";

import type {
  Procedure,
  ProcedureDetail,
  ProcValidation,
  SmartApplyValidationResult,
} from "../../../../application/domain/proc-management";
import {
  AtStoreInfoSection,
  ByMailInfoSection,
  InPersonInfoSection,
  OnlineInfoSection,
  RelationsSection,
  RequirementSection,
  SummarySection,
  SupportSection,
} from ".";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  onFileAttached: (
    path: (string | number)[],
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  getFileUploading: (path: (string | number)[]) => boolean;
  isServiceProviderAccount?: boolean;
  disabled?: boolean;
  shouldDisplayError?: boolean;
  validationErrors: ProcValidation;
  smartApplyValidationResult: SmartApplyValidationResult;
};

export const ProcedureForm: React.FC<Props> = ({
  procedure,
  onChange,
  onFileAttached,
  getFileUploading,
  isServiceProviderAccount = false,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
  smartApplyValidationResult,
}) => {
  return (
    <div>
      <SummarySection
        procedure={procedure}
        onChange={onChange}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <RequirementSection
        procedure={procedure}
        onChange={onChange}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <OnlineInfoSection
        procedure={procedure}
        onChange={onChange}
        isServiceProviderAccount={isServiceProviderAccount}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
        smartApplyValidationResult={smartApplyValidationResult}
      />
      <ByMailInfoSection
        procedure={procedure}
        onChange={onChange}
        onFileAttached={onFileAttached}
        getFileUploading={getFileUploading}
        isServiceProviderAccount={isServiceProviderAccount}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <InPersonInfoSection
        procedure={procedure}
        onChange={onChange}
        onFileAttached={onFileAttached}
        getFileUploading={getFileUploading}
        isServiceProviderAccount={isServiceProviderAccount}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <AtStoreInfoSection
        procedure={procedure}
        onChange={onChange}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <SupportSection
        procedure={procedure}
        onChange={onChange}
        onFileAttached={onFileAttached}
        getFileUploading={getFileUploading}
        isServiceProviderAccount={isServiceProviderAccount}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
      <RelationsSection
        procedure={procedure}
        onChange={onChange}
        isServiceProviderAccount={isServiceProviderAccount}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors}
      />
    </div>
  );
};

export default ProcedureForm;
